import { Link, useLocation } from 'react-router-dom';
import * as style from '../../utils/general_style.js';
import * as links from '../../utils/general_links.js';

function NavButton({ name, path, isOpen, onClick }) {

	const location = useLocation();
	
	const navButtonStyle = {
		...style.COLUMN_CENTER,
		color: style.COLORS.white,
		width: '25%',
		height: '40px',
		cursor: 'pointer',
		backgroundColor: (location.pathname === path) || (name === 'Étude de sol' && (location.pathname === links.ROUTES.presentation || location.pathname === links.ROUTES.loiElan )) ? style.COLORS.tertiary : 'inherit'
	};

	const dropDownItemStyle = {
		...style.ROW_CENTER,
		height: '40px',
		width: '100%',
		border: `1px solid ${style.COLORS.white}`,
		backgroundColor: (location.pathname === path) ? style.COLORS.tertiary : style.COLORS.secondary
	};

	const eds = (name === 'Étude de sol') ? true : false;
	return (
		<>
			{eds && 
				<>
					<div id={'dropDownContainer'} style={{...navButtonStyle, height: 'auto', position: 'relative', top: isOpen ? '40px' : '0', backgroundColor: 'inherit'}}>
					<div style={{...navButtonStyle, width: '100%'}} onClick={onClick}>Étude de sol</div>
					{isOpen &&
						<>
							<Link to={links.ROUTES.presentation} style={dropDownItemStyle} onClick={onClick}>Présentation</Link>
							<Link to={links.ROUTES.loiElan} style={{...dropDownItemStyle, position: 'relative', top: '-1px'}} onClick={onClick}>Loi ELAN</Link>
						</>
					}
					</div>
				</>
			}
			{!eds &&
				<>
					<div style={navButtonStyle}>
						<Link to={path} style={{color: 'white'}} onClick={onClick}>
							<p>{name}</p>
						</Link>
					</div>
				</>
			}
		</>
	);
};

export default NavButton;